import { IDriveApiClientExtension } from "./DriveApiClientExtension";

export class DriveHelpers {
    private readonly driveApiClientExtension: IDriveApiClientExtension;

    public constructor(driveApiClientExtension: IDriveApiClientExtension) {
        this.driveApiClientExtension = driveApiClientExtension;
    }

    public async ensureCandyFrontSrv(driveUri: string): Promise<string> {
        if (driveUri.toLowerCase().includes("srv/candyfront") || driveUri.toLowerCase().includes("srv/keforms")) {
            return driveUri;
        }

        const index = driveUri.indexOf("srv/");
        const prefix = driveUri.substring(0, index);
        const uri = driveUri.substring(index);

        const result = await this.driveApiClientExtension.copyContents(
            uri,
            uri.replace(/srv\/[^\/]+/g, "srv/candyFront")
        );

        return prefix + result.Name;
    }
}
